import {createElement} from 'rlink-react';
import warnOnce from 'rlink-debug-utils/warnOnce';

export default function (path, type = 'img') {
  try {
    switch (type) {
      case 'img':
        return require(`../img/${path}`);
        break;
      case 'video':
        return require(`../video/${path}`);
        break;
      default:
        throw new Error(`Invalid content loader type: ${type}`);
    }
  } catch (e) {
    warnOnce(`Couldn't load the ${type}: ${path}. Make sure this file exists.`);
  }

}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/contentLoader.js